import { render } from "./LandingLayout.vue?vue&type=template&id=4b02fa68"
import script from "./LandingLayout.vue?vue&type=script&lang=js"
export * from "./LandingLayout.vue?vue&type=script&lang=js"

import "./LandingLayout.vue?vue&type=style&index=0&id=4b02fa68&lang=css"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__